import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

import { useGetUserQuery } from 'store/api/version-api.slice';

import { styles } from './styles';

const AccessHubspotButton = () => {
	const { data: user, isLoading: isUserLoading } = useGetUserQuery();
	const portal_id = user?.portalid;

	return (
		<Button
			fullWidth
			component={Link}
			href={`https://app.hubspot.com/contacts/${portal_id}/contacts`}
			target={'_blank'}
			variant="outlined"
			sx={styles.BtnHubSpot}
			disabled={isUserLoading}
		>
			access your HubSpot account
		</Button>
	);
};

export default AccessHubspotButton;
